const useGoogleMap = () => {
  const hasLocationDataBeenPopulated = ref(false);
  const isLocationDataAvailable = ref(true);
  const currentLocationData = ref({
    delivery: [],
    pickup: [],
  });

  const populateLocationData = (jobArray = []) => {
    if (hasLocationDataBeenPopulated.value) {
      return;
    }

    jobArray.forEach(({ deliveryLocation, pickupLocation }) => {
      // there are cases where location data is not available.
      // if at any point in the loop lat/lng is not available
      // we return and do not display any map markers
      if (!deliveryLocation?.addressLatitude) {
        isLocationDataAvailable.value = false;
        return;
      }

      currentLocationData.value.delivery.push({
        position: {
          lat: deliveryLocation?.addressLatitude,
          lng: deliveryLocation?.addressLongitude,
        },
      });

      currentLocationData.value.pickup.push({
        position: {
          lat: pickupLocation?.addressLatitude,
          lng: pickupLocation?.addressLongitude,
        },
      });
    });

    hasLocationDataBeenPopulated.value = true;
  };

  return {
    populateLocationData,
    isLocationDataAvailable,
    currentLocationData,
  };
};

export default useGoogleMap;
